module.exports = __webpack_public_path__ + "static/media/5h_website_logo_diamond_sino.5d091901.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5h_website_logo_diamond_sino.jpg
// module id = 92
// module chunks = 0